"use client";
import React from "react";
import style from "@/styles/IntegratonsFeature.module.scss";
import Image from "next/image";
import ResponsiveSwiper from "./ResponsiveSwiper";
import { usePathname } from "next/navigation";
import Link from "next/link";

const IntegratonsFeature = () => {
  const router = usePathname();

  // Example datasets
  const data = {
    sectiontop:"FEATURES",
    sectiontitle: "Next-Generation Key Features of Vidyalaya LMS Mobile App",
    sectiondesc:"Engagement & Personalization",
    carddetails: [
      {
        title: "Live Classroom",
        para: "We offer live Zoom classes that let students learn from anywhere and interact with instructors in real time.",
        img: "/images/feature_section/1.png",
        link: "#"
      },
      {
        title: "Recorded Classroom",
        para: "All classes are recorded, allowing students to watch them at their convenience and eliminating the need for repetition.",
        img: "/images/feature_section/2.png",
        link: "#"
      },
      {
        title: "Quiz Module",
        para: "The quiz module lets users take timed multiple-choice quizzes to test their knowledge and enhance learning.",
        img: "/images/feature_section/3.png",
        link: "#"
      },
      {
        title: "Gamification",
        para: "Enhance learner motivation with badges, points, leaderboards, and rewards.",
        img: "/images/feature_section/4.png",
        link: "#"
      },
      {
        title: "Interactive Tools",
        para: "Foster collaboration through forums, chat groups, and messaging features.",
        img: "/images/feature_section/5.png",
        link: "#"
      },
      {
        title: "Learning Paths",
        para: "Create structured learning journeys tailored to individual learner needs.",
        img: "/images/feature_section/6.png",
        link: "#"
      }
    ]
  };

  const datatwo = {
      secondfeaturesection: true,
      sectiondesc:"Integrations & Customization",
      carddetails: [
      {
        title: "Payment Gateway Integration",
        para: "Accept course and subscription payments via secure payment gateways.",
        img: "/images/feature_section/7.png",
        link: "#"
      },
      {
        title: "Third-Party Integrations",
        para: "Seamlessly integrates with video conferencing, email, biometric systems, and more",
        img: "/images/feature_section/8.png",
        link: "#"
      },
      {
        title: "Video Conferencing Integration",
        para: "Vidyalaya LMS supports Zoom and Google Meet for real-time virtual classes.",
        img: "/images/feature_section/9.png",
        link: "#"
      },
      {
        title: "White Labelling",
        para: "Customize the LMS interface to reflect your institution's branding for a personalized experience.",
        img: "/images/feature_section/10.png",
        link: "#"
      },
      {
        title: "Single Sign-On(SSO)",
        para: "Vidyalaya LMS supports SSO, allowing users to log in once to access multiple systems securely without the need for multiple passwords.",
        img: "/images/feature_section/11.png",
        link: "#"
      },
      {
        title: "Content Integration",
        para: "Easily integrate with external content sources, such as YouTube or Vimeo, for video streaming or other learning resources.",
        img: "/images/feature_section/12.png",
        link: "#"
      }
    ]
  };

  const pageArray = ["/"]; // pages that should render second section
  const secondsection = pageArray.includes(router);

const renderSection = (sectionData) => (
  <section
  className={`${style.featuresection} ${sectionData.secondfeaturesection ? style.seconfeature : ""}`} >
    <div className="container">
      {sectionData.sectiontop && (
        <div className={style.Orangespandiv}>
          <span className={style.Orangespan}>{sectionData.sectiontop}</span>
        </div>
      )}

      {sectionData.sectiontitle && (
        <h3 className={`${style.sectiontitle} commonsectiontitle`}>
          {sectionData.sectiontitle}
        </h3>
      )}

      {sectionData.sectiondesc && (
        <p className={style.sectiondesc}>{sectionData.sectiondesc}</p>
      )}

      <div className={style.cardrow}>
        <ResponsiveSwiper
          swiperConfig={{
            spaceBetween: 20,
            slidesPerView: "auto",
            loop: true,
            autoplay: { delay: 2500, disableOnInteraction: false },
            pagination: { clickable: true },
            breakpoints: {
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            },
            navigation: true,
            className: "commonswiperclass prevnextpadding w-100",
          }}
        >
          {sectionData.carddetails.map((item, index) => (
            <div key={index} className={style.card}>
              <div className={style.cardimage}>
                <Image
                  src={item.img}
                  alt={item.title}
                  width={400}
                  height={200}
                  className={style.cardimg}
                />
              </div>
              <div className={style.cardContent}>
                <h4>{item.title}</h4>
                <p>{item.para}</p>
              </div>
            </div>
          ))}
        </ResponsiveSwiper>
      </div>
    </div>
  </section>
);


  return (
    <>
   {renderSection(data)}
   {secondsection && renderSection(datatwo)}
   </>
  );
};

export default IntegratonsFeature;
